import { AuditLogCatalogSection, AuditLogEvent, AuditLogQuery } from 'services/auditLogs/types'
import actions from './actions'

/** Team members by lower-cased email; an actor missing here is no longer on the team. */
export type ActorDirectory = Record<string, { name: string }>

export interface AuditLogsState {
  auditLogsList: AuditLogEvent[]
  areAuditLogsLoading: boolean
  auditLogsError: string | null
  /** True after the first list response (success or error), so the UI can tell empty from loading. */
  hasLoadedOnce: boolean
  nextCursor: string | null
  /** The cursor used to load each visited page; index 0 is always null. */
  cursorStack: (string | null)[]
  pageIndex: number
  query: AuditLogQuery
  catalog: AuditLogCatalogSection[]
  isCatalogLoading: boolean
  actorOptions: string[]
  actorDirectory: ActorDirectory
  selectedAuditLog: AuditLogEvent | null
  isAuditLogLoading: boolean
  auditLogNotFound: boolean
  auditLogError: string | null
  isExporting: boolean
}

export const initialState: AuditLogsState = {
  auditLogsList: [],
  areAuditLogsLoading: false,
  auditLogsError: null,
  hasLoadedOnce: false,
  nextCursor: null,
  cursorStack: [null],
  pageIndex: 0,
  query: {},
  catalog: [],
  isCatalogLoading: false,
  actorOptions: [],
  actorDirectory: {},
  selectedAuditLog: null,
  isAuditLogLoading: false,
  auditLogNotFound: false,
  auditLogError: null,
  isExporting: false,
}

interface AuditLogsAction {
  type: string
  payload?: Partial<AuditLogsState>
}

export default function auditLogsReducer(
  state: AuditLogsState = initialState,
  action: AuditLogsAction,
): AuditLogsState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.RESET:
      return initialState
    default:
      return state
  }
}
